import React from 'react';
import './styles/Loader.css';

const FullScreenLoader: React.FC = () => {
  return (
    <div className="fullscreen-loader" role="status" aria-live="polite" aria-label="Загрузка">
      <div className="fullscreen-loader-page" aria-hidden="true">
        <div className="loader-skeleton-topbar">
          <span className="loader-skeleton loader-skeleton-logo" />
          <span className="loader-skeleton loader-skeleton-menu" />
        </div>
        <div className="loader-skeleton loader-skeleton-title" />
        <div className="loader-skeleton loader-skeleton-copy" />
        <div className="loader-skeleton loader-skeleton-copy loader-skeleton-copy-short" />
        <div className="loader-skeleton-card">
          <span className="loader-skeleton loader-skeleton-card-icon" />
          <div className="loader-skeleton-card-lines">
            <span className="loader-skeleton loader-skeleton-card-title" />
            <span className="loader-skeleton loader-skeleton-card-copy" />
          </div>
        </div>
        <span className="loader-skeleton loader-skeleton-button" />
      </div>
    </div>
  );
};

export default FullScreenLoader;